export const DATE_FORMAT_DAY = 'yyyy-MM-dd';
export const DATE_FORMAT_MINUTES = 'yyyy-MM-dd HH:mm';
export const DATE_FORMAT_SECONDS = 'yyyy-MM-dd HH:mm:ss';
export const MOMENT_DATE_FORMAT_DAY = 'YYYY-MM-DD';
export const MOMENT_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm';
export const MOMENT_DATE_FORMAT_SECONDS_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const TIME_FORMAT = 'HH:mm';

// See the Moment.js docs for the meaning of these formats:
// https://momentjs.com/docs/#/displaying/format/
export const MEXOS_MAT_MOMENT_DATE_FORMATS = {
  parse: {
    dateInput: MOMENT_DATE_FORMAT_DAY,
  },
  display: {
    dateInput: MOMENT_DATE_FORMAT_DAY,
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: MOMENT_DATE_FORMAT_DAY,
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


export const MEXOS_MAT_MOMENT_DATE_TIME_FORMATS = {
  parse: {
    dateInput: MOMENT_DATE_FORMAT_DAY,
    monthInput: 'MMMM',
    timeInput: TIME_FORMAT,
    datetimeInput: MOMENT_DATE_TIME_FORMAT
  },
  display: {
    dateInput: MOMENT_DATE_FORMAT_DAY,
    monthInput: 'MMMM',
    datetimeInput: MOMENT_DATE_TIME_FORMAT,
    timeInput: TIME_FORMAT,
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
    popupHeaderDateLabel: 'ddd, DD MMM'
  }
};

